export const HEADER_STRIPE_ACCOUNT_ID = 'x-clubspark-stripe-account-id';
export const HEADER_ROOT_PROVIDER_ID = 'x-clubspark-root-provider-id';
export const HEADER_PROVIDER_ID = 'x-clubspark-provider-id';
export const HEADER_ORGANISATION_ID = 'ClubSpark-Organisation-Id';
